import { useMemo } from "react"

export const useData = (
  isComparing: boolean,
  compareUniqueKey: string | undefined,
  metrics: Record<string, unknown>[],
) => {
  const data = useMemo(
    () =>
      isComparing && compareUniqueKey
        ? (metrics[0] as unknown as Record<string, unknown>[])
        : (metrics as Record<string, unknown>[]),
    [isComparing, compareUniqueKey, metrics],
  )

  const noData = useMemo(
    () =>
      !data ||
      data.length === 0 ||
      (isComparing && (metrics[0] as unknown as unknown[]).length === 0),
    [data, isComparing, metrics],
  )

  const compareData = useMemo(
    () =>
      isComparing && compareUniqueKey
        ? (metrics[1] as unknown as Record<string, unknown>[])
        : null,
    [isComparing, compareUniqueKey, metrics],
  )

  return { data, noData, compareData }
}
